import * as React from "react";
function SvgSource(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M37.3 10c-1.2 0-2.4.2-3.6.6-.2-1.9-1.2-4.4-4.3-6.8-2-1.7-4.7-2.4-7.3-1.9-3.9.7-7 3.6-8 7.4-1.3-.3-2.8-.3-4.1-.1-3.5.8-6 3.6-6.4 7-.1 1-.1 2 .1 3-2.4 1.1-3.8 3.3-3.7 6 0 1.9.8 3.6 2.3 4.9 1.1 1.1 2.6 1.6 4.1 1.4h6.8v-2.4H5.9c-.8 0-1.7-.2-2.3-1-.8-.7-1.4-1.8-1.4-3 0-1.8 1-3.7 2.7-3.9l1.8-.1-.6-1.4c-.5-1-.6-2-.5-3.1.4-2.5 2.1-4.5 4.7-5 1.3-.4 2.7-.1 3.9.5l1.6.7.1-1.7c.4-3.5 2.9-6.2 6.3-6.8 1.9-.2 3.9.2 5.5 1.6 3.2 2.4 3.6 4.5 3.5 6.4l.1 2.3 1.7-1c3.9-2.3 9.1-1 11.5 3 .7 1.3 1.1 2.7 1.1 4.2 0 2.6-1.3 5.1-3.6 6.7-1.4 1-3.1 1.4-4.8 1.3h-2.5v2.4h2.6c5.7.2 10.5-4.3 10.7-10v-.5C47.9 14.8 43.1 10 37.3 10zm-6.8 26.9l-5.4 5.3V22.5c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2v19.7l-5.4-5.4c-.5-.5-1.3-.4-1.7.1s-.4 1.1 0 1.6l7.4 7.4c.5.5 1.2.5 1.7 0l7.4-7.4c.5-.5.5-1.2 0-1.7-.5-.4-1.3-.4-1.6.1z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSource);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
